<template>
  <div>
    <DataTable :headers="headers" :path="path" :filterPath="filterPath" :properties="properties"
               :action-buttons-name="actionButtonsName" filter toolbar :toolbar-title="toolbarTitle"
               :search-text="searchText">
      <slot slot="toolbar-table"></slot>
    </DataTable>
    <presentacion-create-popup v-if="canCreate" ref="creacionPopup"></presentacion-create-popup>
    <v-btn v-if="canCreate" app dark fixed fab bottom right class="add-button" @click="newPresentacion">
      <v-icon>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import PresentacionCreatePopup from '../components/PresentacionCreatePopup'

const PRESENTED_DATE_INDEX_IN_TABLE = 2
const CLUB_INDEX_IN_TABLE = 6

export default {
  methods: {
    newPresentacion () {
      this.$refs.creacionPopup.showDialog()
    }
  },
  props: {
    actionButtonsName: {
      type: String,
      default: 'PresentacionListActionButtons'
    },
    path: {
      type: String,
      default: 'presentacion'
    },
    filterPath: {
      type: String,
      default: 'filters/presentations'
    },
    thirdColumn: {
      type: Object,
      default: () => { return { text: 'Vencimiento', value: 'expiration' } }
    },
    initialProperties: {
      type: Array,
      default: () => { return ['nombre', 'mandatoryPresentationType', 'submitted', 'fechaVencimiento', 'period', 'estadoDisplayTable'] }
    },
    initialHeaders: {
      type: Array,
      default: () => { return [] }
    },
    toolbarTitle: {
      type: String,
      default: 'Presentaciones'
    },
    searchText: {
      type: String,
      default: 'Buscar por nombre de presentación o periodo'
    },
    mandatory: {
      type: Boolean,
      default: true
    }
  },

  components: {
    DataTable,
    PresentacionCreatePopup
  },

  computed: {
    canCreate () {
      return this.$store.state.permissions.canAddPresentaciones
    },
    headers () {
      if (this.initialHeaders.length > 0) {
        return this.initialHeaders
      }

      let headers = [
        { text: 'Nombre', align: 'left', value: 'nombre', sortable: false },
        { text: 'Tipo', value: 'mandatory_presentation_type', sortable: true },
        this.thirdColumn,
        { text: 'Periodo', value: 'period', sortable: true },
        { text: 'Estado', value: 'status', filterField: true },
        { text: 'Año', value: 'year', filterField: true, visible: false },
        { text: 'Acciones', align: 'right', sortable: false }
      ]
      if (this.$store.getters.isSafRole) {
        headers.splice(CLUB_INDEX_IN_TABLE, 0, { text: 'Club', value: 'club', filterField: true })
      }
      if (this.mandatory) {
        headers.splice(PRESENTED_DATE_INDEX_IN_TABLE, 0, { text: 'Fecha de Presentación', value: 'submitted' })
      }
      return headers
    },
    properties () {
      let properties = this.initialProperties
      if (this.$store.getters.isSafRole) {
        properties.splice(CLUB_INDEX_IN_TABLE, 0, 'club.nombre')
      }
      return properties
    }
  }
}
</script>
